export class ApiError extends Error {
  public readonly response: Response;

  public constructor(response: Response) {
    super(response.statusText);
    this.response = response;
  }
}
